import React from "react";
import { Link } from "react-router-dom";
import { useLang, pick } from "../i18n/LanguageContext";
import { t } from "../i18n/translations";
import companyLogo from "../assets/logos/Hetki-logo_white.png";
import filmLogo from "../assets/logos/Hetki-Company-Film-logo_white.png";

/**
 * Gateway — koko ruudun kahtiajako, josta valitaan kumpaan puoleen astutaan:
 * Hetki Company (viestintä ja markkinointi) vai Hetki Film Company
 * (elokuvat ja sarjat). Koko paneeli on linkki; painike näyttää, että puolta
 * voi klikata, ja hoverissa sen puolen valopallo kirkastuu (index.css).
 */
const Gateway = () => {
  const { lang } = useLang();
  const tr = pick(lang);

  return (
    <div className="gateway">
      <Link to="/hetki" className="gateway__panel gateway__panel--company">
        <div className="gateway__content">
          <img className="gateway__logo" src={companyLogo} alt="Hetki" width="1459" height="698" />
          <p className="gateway__desc">{tr(t.gateway.companyDesc)}</p>
          <span className="gateway__enter">
            {tr(t.gateway.companyEnter)}
            <span className="gateway__arrow" aria-hidden="true">→</span>
          </span>
        </div>
      </Link>

      <Link to="/film" className="gateway__panel gateway__panel--film">
        <div className="gateway__content">
          <img className="gateway__logo" src={filmLogo} alt="Hetki Film Company" width="4895" height="698" />
          <p className="gateway__desc">{tr(t.gateway.filmDesc)}</p>
          <span className="gateway__enter">
            {tr(t.gateway.filmEnter)}
            <span className="gateway__arrow" aria-hidden="true">→</span>
          </span>
        </div>
      </Link>
    </div>
  );
};

export default Gateway;
